export const POLICY_APP_INFO = "app_info";
// this is protecting /profile, so all roles need this
export const POLICY_EXP_ACC = "exp_acc";
// this is protected the private /config, so CM needs this.
export const POLICY_CONTENT_EDIT = "content_edit";
// ability for experts to view secure data in EWA
export const POLICY_SENSITIVE_DATA_VIEW_ACCESS = "sdata_view_exp";
// ability for experts to request secure data in EWA
export const POLICY_SENSITIVE_DATA_REQUEST_ACCESS = "sdata_request_exp";
// ability for experts to view/request secure data in CM
export const POLICY_SENSITIVE_DATA_ACCESS_CM = "sdata_access_cm";
// ability for experts to edit group tags in CM
export const POLICY_TAG_EDIT_CM = "tag_edit_cm";
// users with this policy needs to have their MFA setup, if not already
export const POLICY_MFA_REQUIRED = "mfa_required";
//ability for user to show message in CM
export const POLICY_APP_ACCESS_CM = "app_access_cm";
//ability to show dashboard,payment and activity in EWA
export const POLICY_PAYMENTS_ACCESS = "expert_payments_access";
//ability to withdraw and see Payment nav item
export const POLICY_WITHDRAWAL_ACCESS = "expert_request_withdrawal";
//ability to view and change dark mode
export const POLICY_DARK_MODE = "drk_mode";
//ability to access expert's-app
export const POLICY_APP_ACCESS_EWA = "app_access_ewa";